/* Automatic generated by './build/bin/build-entry.js' */

import Header from './header/index.js';

const components = [
  Header
];

const install = function(Vue) {
	Object.keys(components).forEach((key) => {
    Vue.component(components[key].name, components[key])
  })
  /*components.map(component => {
    Vue.component(component.name, component);
  });*/
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
};

export default install




// WEBPACK FOOTER //
// ./src/packages/index.js